import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from "../../stores/auth-store.js";

// Component to handle redirection after login based on stored redirect state
const RedirectHandler = () => {
  const navigate = useNavigate();
  const redirectTo = useAuthStore(state => state.redirectTo);
  const clearRedirect = useAuthStore(state => state.clearRedirect);
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  useEffect(() => {
    if (redirectTo && redirectTo.path && isAuthenticated) {
      // Perform the navigation
      navigate(redirectTo.path, { 
        state: redirectTo.state, 
        replace: true 
      });
      clearRedirect();
    } else if (redirectTo && !isAuthenticated) {
      console.log("RedirectHandler: Detected unauthenticated redirect. Preserving for login:", redirectTo.path);
    }

  }, [redirectTo, isAuthenticated, navigate, clearRedirect]);
  
  return null; // This component doesn't render anything
};

export default RedirectHandler;